// Generated by Go - DO NOT EDIT
// 2026-11-04 13:58:22.187627751 +0000 UTC m=+0.002927970

const routes = {
  "asyncJobStatusURL": "/api/v1/async-job-status/",
  "fileBaseURL": "/datei/",
  "filesBaseURL": "/dateien"
};

export default routes;